import * as React from "react";
import { ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";
import { translate } from "@/services/TranslationService";

const normalize = (str = "") =>
  str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

const Autocomplete = ({
  options = [],
  value,
  onValueChange,
  placeholder = "Type to search...",
  className,
}) => {
  const [query, setQuery] = React.useState(value ? value.label : "");
  const [open, setOpen] = React.useState(false);
  const [hasInteracted, setHasInteracted] = React.useState(false);

  const filtered = !hasInteracted
    ? options
    : options.filter(
      (opt) =>
        normalize(opt?.label).includes(normalize(query))
    );


  React.useEffect(() => {
    setQuery(value ? value.label : "");
    onValueChange(value);
  }, [value]);

  return (
    <div className="relative w-full">

      <div
        className={cn(
          "flex h-10 w-full items-center justify-between rounded-md border border-gray-200 bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50 [&>span]:line-clamp-1 focus-within:border-strongCyan",
          className
        )}
      >
        <input
          className="w-full bg-transparent outline-none"
          value={query || ""}
          placeholder={placeholder}
          onChange={(e) => {
            setQuery(e.target.value);
            setOpen(true);
            setHasInteracted(true);
          }}
          onFocus={() => setOpen(true)}
          onBlur={() => {
            const exactMatch = options.find(
              (opt) => normalize(opt.label) === normalize(query)
            );

            if (exactMatch) {
              onValueChange(exactMatch);
              setQuery(exactMatch.label);
            }

            setTimeout(() => setOpen(false), 150);
          }}
        />
        <ChevronDown className="h-4 w-4 opacity-50" />
      </div>


      {open && filtered.length > 0 && (
        <ul className="absolute z-10 mt-1 w-full max-h-60 overflow-auto rounded-md border bg-popover text-popover-foreground shadow-md flex flex-col">
          {filtered.map((item) => (
            <li
              key={item.value}
              onMouseDown={() => {
                onValueChange(item);
                setQuery(item.label);
                setOpen(false);
              }}
              className={cn(
                "cursor-pointer px-3 py-2 text-sm text-left",
                item.value === value?.value
                  ? "bg-accent text-accent-foreground"
                  : "hover:bg-accent hover:text-accent-foreground"
              )}
            >
              {item.label}
            </li>
          ))}
        </ul>
      )}
      {
        open && filtered.length === 0 && (
          <div className="absolute z-10 mt-1 w-full rounded-md border bg-popover text-popover-foreground shadow-md">
            <div className="px-3 py-2 text-sm">{translate('No results found')}</div>
          </div>
        )
      }
    </div>
  );
};

export default Autocomplete;